// extracted by mini-css-extract-plugin
module.exports = {"element":"_0fce717cdb--element--2vdm4"};